import { useMedia } from '#hooks/use-media.js';

export default function useDetail(props) {
    const { selectedUser, editUser, setUnsavedChanges } = props;

    const imageProfileData = useMedia({
        initialData: selectedUser?.imageProfile,
        onAdd: (media) => {
            editUser(selectedUser.id, 'imageProfile', media);
        },
        onUpload: (media) => {
            editUser(selectedUser.id, 'imageProfile', media);
        },
        onDelete: () => {
            editUser(selectedUser.id, 'imageProfile', null);
        }
    });

    const imageProfile = imageProfileData.data ? imageProfileData.data?.meta : selectedUser?.imageProfile;
    const handleChange = (e) => {
        const { name, value } = e.target;
        setUnsavedChanges(true);
        editUser(selectedUser.id, name, value);
    };

    const handleChangeCheckbox = (e) => {
        const { name, checked } = e.target;
        setUnsavedChanges(true);
        editUser(selectedUser.id, name, checked);
    };

    return {
        handleChange,
        handleChangeCheckbox,
        imageProfile,
        imageProfileData
    };
}
